import React from 'react'
import Wrapper from './style'

const SchCardItem = ({ img, name, price, scholarzId, onClick, active, amount}) => {
	return (
		<Wrapper
			active={active}
			onClick={active ? onClick : () =>{} }
		>
			<div className="amount">{amount}</div>
			<div className="traits-img">
				<input
					type="image"
					src={img}
					alt={`traits-${name}`}
					disabled={!active}
				/>
			</div>
			<div className="name">{name}</div>
			{price
				&& (
					<div
						className="price"
					>
						{price}&nbsp;
						<span>$ EXP</span>
					</div>
				)
			}
			<div className="scholarz-id">
				#{scholarzId}
			</div>
		</Wrapper>
	)
}

export default SchCardItem
